import { TextareaAutosize } from "@mui/base";
import Lottie from "lottie-react";
import { Controller, useFormContext } from "react-hook-form";

import ottoScribblesBuild from "../../../../../assets/imgs/otto-scribbles-build.json";
import EmptyState from "../../../../common/loading/EmptyState";
import { TranscriptSampleChipMenu } from "../ExamplesChipMenu";

const PreviewingAgainstSample = ({
  control,
  handleClearSampleTranscript,
}) => {
  const { watch } = useFormContext(control);
  const formData = watch();

  return (
    <div className="flex flex-col gap-2">
      <TranscriptSampleChipMenu
        control={control}
        handleClearSampleTranscript={handleClearSampleTranscript}
      />
      <div className="font-medium text-xs whitespace-pre-wrap rounded-xl p-4 text-gray-600 dark:text-gray-300 border-dashed border-2 border-gray-100 dark:border-gray-700">
        {formData.sampleTranscript}
      </div>
    </div>
  );
};

const PreviewSection = ({
  control,
  loadingPreview,
  handleClearSampleTranscript,
}) => {
  const { watch } = useFormContext(control);
  const formData = watch();

  return (
    <div className="overflow-y-auto w-full relative">
      {loadingPreview ? (
        <div className="flex flex-row items-center justify-between border-dashed border-2 border-indigo-100 bg-indigo-50 dark:bg-gray-700/20 dark:border-gray-700 rounded-xl p-6 gap-4">
          <EmptyState
            title="Building your template..."
            description="This may take up to a minute. It's hard to do things without opposable thumbs, ya know."
          >
            <Lottie
              animationData={ottoScribblesBuild}
              className="w-[300px]"
              loop={true}
              autoplay={true}
            />
          </EmptyState>
          <div className="font-medium text-xs whitespace-pre-wrap rounded-xl p-4 text-gray-600 dark:text-gray-300 bg-white dark:bg-gray-800 max-w-64">
            <strong className="text-sm">
              Selected Sample:{"\n"}
            </strong>
            {formData.sampleTranscript}
          </div>
        </div>
      ) : formData.preview ? (
        <Controller
          control={control}
          name="preview"
          render={({ field }) => (
            <TextareaAutosize
              id="preview"
              name="preview"
              data-testid="preview-template-textarea"
              minRows={5}
              value={field.value}
              onChange={(e) => {
                field.onChange(e);
              }}
              readOnly
              className="resize-none appearance-none relative block w-full p-4 border-dashed border-2 border-indigo-100 bg-indigo-50 dark:bg-gray-700/20 dark:border-gray-700 placeholder-gray-400 text-gray-900 dark:text-gray-100 rounded-xl z-10 text-xs md:text-sm h-8"
            />
          )}
        />
      ) : (
        <div className="relative w-full">
          <PreviewingAgainstSample
            control={control}
            handleClearSampleTranscript={handleClearSampleTranscript}
          />
        </div>
      )}
    </div>
  );
};

export default PreviewSection;
